import APP_ROUTES from "src/routes/routes";
import { usePatchedNavigate } from "../usePatchedNavigate";
import { useQuery } from "../useReactQuery";
import { getAllTags } from "src/services/tags-service";

const useGetAllTags = (params) => {
  const { page = 1, limit = 9999999, q, enabled = true, refetchOnWindowFocus = true, isSelectOptions } = params || {};
  const navigate = usePatchedNavigate();

  const { data, isError, error, refetch, isFetching } = useQuery({
    queryKey: ["getAllTags"],
    queryFn: () => {
      const params = { page, limit, q };
      return getAllTags(params);
    },
    select: (data) => {
      let finalData = data;

      if (isSelectOptions) {
        return (
          finalData?.items?.map((item) => ({
            label: item.name,
            value: item.id,
          })) || []
        );
      }
      return finalData;
    },
    enabled,
    refetchOnWindowFocus,
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
  });

  return {
    data,
    refetch,
    isFetching,
    isError,
    error,
  };
};

export default useGetAllTags;
